import './App.css';
import './Home.js'
import Home from './Home.js'
import Footer from './Footer.js'
import Navbar from './Navbar.js'
import Projects from './Projects.js'
import AboutMe from './AboutMe.js'
import Papers from './Papers.js'
import WorkExperience from './WorkExperience.js';
import {Routes, Route} from 'react-router-dom'
import {useState, useEffect} from 'react'
function App() {
  const[showNavbar, setShowNavbar] = useState(false);
    useEffect(()=>{
        const handleNavbar = ()=>{
            if(window.scrollY>300){
                setShowNavbar(true);
            }
            else{
                setShowNavbar(false);
            }
        }
        window.addEventListener("scroll", handleNavbar)
    });
  return (
    <div className="App" >
        <Navbar showNavbar = {showNavbar}/>
        <Routes>
          <Route path="/" element = {<Home/>}/>
          <Route path="/aboutMe" element = {<AboutMe showNavbar = {showNavbar} setShowNavbar = {setShowNavbar}/>}/>
          <Route path="/projects" element = {<Projects/ >}/>
          <Route path="/workExperience" element = {<WorkExperience setShowNavbar = {setShowNavbar}/>}/>
          <Route path="/papers" element = {<Papers showNavbar = {showNavbar} setShowNavbar = {setShowNavbar}/>}/>
        </Routes>
        <Footer/>
    </div>
  );
}

export default App;
